/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PurposeRecommendedReleases,
    PurposeRecommendedReleasesFromJSON,
    PurposeRecommendedReleasesFromJSONTyped,
    PurposeRecommendedReleasesToJSON,
} from './PurposeRecommendedReleases';

/**
 * GET /purposes/{purpose_id}/recommended_releases
 * @export
 * @interface GetPurposeRecommendedReleasesSuccessResponse
 */
export interface GetPurposeRecommendedReleasesSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPurposeRecommendedReleasesSuccessResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetPurposeRecommendedReleasesSuccessResponse
     */
    message: string;
    /**
     * 
     * @type {PurposeRecommendedReleases}
     * @memberof GetPurposeRecommendedReleasesSuccessResponse
     */
    data: PurposeRecommendedReleases;
}

export function GetPurposeRecommendedReleasesSuccessResponseFromJSON(json: any): GetPurposeRecommendedReleasesSuccessResponse {
    return GetPurposeRecommendedReleasesSuccessResponseFromJSONTyped(json, false);
}

export function GetPurposeRecommendedReleasesSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPurposeRecommendedReleasesSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PurposeRecommendedReleasesFromJSON(json['data']),
    };
}

export function GetPurposeRecommendedReleasesSuccessResponseToJSON(value?: GetPurposeRecommendedReleasesSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PurposeRecommendedReleasesToJSON(value.data),
    };
}

